<template>
  <footer class="app-footer">
    <div class="footer-content">
      <slot>
        <a :href="icpLink" target="_blank" rel="noopener noreferrer" class="icp-link">
          {{ icpText }}
        </a>
      </slot>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    icpText: {
      type: String,
      default: '粤ICP备2025392434号'
    },
    icpLink: {
      type: String,
      default: 'https://beian.miit.gov.cn'
    }
  }
}
</script>

<style scoped>
.app-footer {
  margin-top: 2rem;
  padding: 1rem 0;
  text-align: center;
  font-size: 0.875rem;
  color: var(--text-secondary, #666);
  border-top: 1px solid var(--border-color, #eee);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.icp-link {
  color: var(--text-secondary, #666);
  text-decoration: none;
}

.icp-link:hover {
  text-decoration: underline;
}

/* 暗色主题支持 */
[data-theme="dark"] .app-footer {
  color: var(--text-secondary, #aaa);
  border-top-color: var(--border-color, #333);
}

[data-theme="dark"] .icp-link {
  color: var(--text-secondary, #aaa);
}
</style> 